import { useFrame, withErrorBoundary } from '~/shared/utils';
import styles from './n11-meta.module.css';
import { memo } from 'react';
import { Usp } from '../components/usp.component';
import { Container } from '~/templates/blocks/components/container/container.component';

const N11Meta = memo(() => {
    const { data } = useFrame();
    const { uspList } = data?.usp || {};

    return (
        <div className={styles.root}>
            <Container hasGutter>
                <div className={styles.inner}>
                    {uspList?.length ? <Usp uspItems={uspList} /> : null}
                </div>
            </Container>
        </div>
    );
});

export default withErrorBoundary(N11Meta);
